/**
 * CraftLink.Api | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const RaceSelfIdentificationCA = {
    BlackCa: 'Black_CA',
    EastAsianCa: 'EastAsian_CA',
    LatinAmericanCa: 'LatinAmerican_CA',
    SouthAsianCa: 'SouthAsian_CA',
    SoutheastAsianCa: 'SoutheastAsian_CA',
    WestAsianCa: 'WestAsian_CA',
    NotAMemberOfAVisibleMinorityCa: 'NotAMemberOfAVisibleMinority_CA',
    OtherCa: 'Other_CA',
    IdoNotWishToProvideThisInformationCa: 'IDoNotWishToProvideThisInformation_CA'
} as const;
export type RaceSelfIdentificationCA = typeof RaceSelfIdentificationCA[keyof typeof RaceSelfIdentificationCA];

